import axios from 'axios';
import { DisplayTypes } from 'shared/constants/FlowConstants';
import showAndGridFactory from 'shared/data/showAndGridFactory';

export default showAndGridFactory(DisplayTypes.show, {
  createGlobalElementContainer(teamId, payload) {
    return axios
      .post('/api/show.createGlobalElementContainer', {
        params: { teamId },
        payload,
      })
      .then((res) => res.data);
  },

  updateGlobalElementContainer(teamId, eventId, showId, payload) {
    return axios
      .post('/api/show.updateGlobalElementContainer', {
        params: { teamId, eventId, showId },
        payload,
      })
      .then((res) => res.data);
  },

  deleteGlobalElementContainer(teamId, eventId, showId) {
    return axios
      .post('/api/show.deleteGlobalElementContainer', {
        params: { teamId, eventId, showId },
      })
      .then((res) => res.data);
  },

  createPDFPreset(teamId, eventId, showId, settings) {
    return axios
      .post('/api/show.createPDFPreset', {
        params: {
          teamId,
          eventId,
          showId,
        },
        payload: settings,
      })
      .then((res) => res.data);
  },

  updatePDFPreset(teamId, eventId, showId, presetId, settings) {
    return axios
      .post('/api/show.updatePDFPreset', {
        params: {
          teamId,
          eventId,
          showId,
          presetId,
        },
        payload: settings,
      })
      .then((res) => res.data);
  },

  recount(teamId, eventId, showId, itemSetListId) {
    return axios
      .post('/api/show.recount', {
        params: {
          teamId,
          eventId,
          showId,
          itemSetListId,
        },
      })
      .then((res) => res.data);
  },

  resetAllStartTimes(teamId, eventId, showId, itemSetListId) {
    return axios
      .post('/api/show.resetAllStartTimes', {
        params: {
          teamId,
          eventId,
          showId,
          itemSetListId,
        },
      })
      .then((res) => res.data);
  },

  clearProofOfPerformance(teamId, eventId, showId, itemSetListId) {
    return axios
      .post('/api/show.clearProofOfPerformance', {
        params: {
          teamId,
          eventId,
          showId,
          itemSetListId,
        },
      })
      .then((res) => res.data);
  },

  get(teamId, eventId, showId) {
    return axios
      .post('/api/show.get', {
        params: {
          teamId: teamId,
          eventId: eventId,
          showId: showId,
        },
      })
      .then((res) => res.data);
  },

  /**
   * Get Show For Guest Pass
   */
  getForGuest(teamId, eventId, showId, query) {
    return axios
      .post('/api/show.getForGuest', {
        params: {
          teamId: teamId,
          eventId: eventId,
          showId: showId,
        },
        query,
      })
      .then((res) => res.data);
  },

  /**
   * Get all shows by global element Id
   */
  getByGlobalElement(teamId, eventId, showId, itemSetId, rowId) {
    return axios
      .post('/api/show.getByGlobalElement', {
        params: { teamId, eventId, showId, itemSetId, rowId },
      })
      .then((res) => res.data);
  },

  /**
   * Get global element show items by show Id
   */
  getGlobalElementShowItems(teamId, eventId, showId) {
    return axios
      .post('/api/show.getGlobalElementShowItemsByShowId', {
        params: { teamId, eventId, showId },
      })
      .then((res) => res.data);
  },

  /**
   * Get global element show items by show Id
   */
  getGlobalElementShowItemsForGuest(teamId, eventId, showId) {
    return axios
      .post('/api/show.getGlobalElementShowItemsByShowIdForGuest', {
        params: { teamId, eventId, showId },
      })
      .then((res) => res.data);
  },

  /**
   * Get event shows
   */
  getByEventId(teamId, eventId) {
    return axios
      .post('/api/event.getShows', {
        params: {
          teamId: teamId,
          eventId: eventId,
        },
      })
      .then((res) => res.data);
  },

  /**
   * Get event shows
   */
  getByEventIdForGuest(teamId, eventId) {
    return axios
      .post('/api/event.getShowsForGuest', {
        params: {
          teamId: teamId,
          eventId: eventId,
        },
      })
      .then((res) => res.data);
  },

  /**
   * Soft delete a show
   */
  hardDelete(teamId, eventId, showId) {
    return axios
      .post('/api/show.hardDelete', {
        params: {
          teamId: teamId,
          eventId: eventId,
          showId: showId,
        },
      })
      .then((res) => res.data);
  },

  /**
   * Archive it (AKA move to trash)
   *
   * @param teamId
   * @param eventId
   * @param showId
   * @returns {*|Promise}
   */
  archive(teamId, eventId, showId) {
    return axios
      .post('/api/show.archive', {
        params: {
          teamId,
          eventId,
          showId,
        },
      })
      .then((result) => result.data);
  },
});

// eslint-disable-next-line no-unused-vars
function _update(teamId, eventId, showId, changes) {
  return axios
    .post('/api/show.update', {
      params: {
        teamId: teamId,
        eventId: eventId,
        showId: showId,
      },
      payload: changes,
    })
    .then((res) => res.data);
}
